<section class="tok-payment-page page-background position-relative overflow-hidden py-4 py-lg-5">
  <div class="container position-relative z-1">

    <div class="text-center mb-4 mb-lg-5">
      <h1 class="page-title display-5 fw-bold mb-3">{{ pageTitle }}</h1>
      <app-progress-stepper
        [currentStep]="RegistrationFlowStep.MembershipOptions"
        [label]="'Select your protection plan'">
      </app-progress-stepper>
    </div>

    <p *ngIf="isMultiPlanTok" class="text-center fw-semibold mb-4">{{ multiPlanIntro }}</p>

    <div class="tok-card-grid row g-4 justify-content-center">

      <div class="col-lg-8 col-12 order-lg-2">
        <div class="tok-card d-flex flex-column h-100 mx-auto border overflow-hidden">
          <span class="tok-card__stripe flex-shrink-0"></span>

          <div class="d-flex flex-column flex-grow-1 py-3 px-4">
            <h2 class="tok-card__title m-0">{{ page.cardTitle }}</h2>
            <p class="tok-card__description mt-2 mb-0">{{ description }}</p>

            <hr class="tok-card__divider my-3" />

            <p class="tok-card__price mt-0 mb-3">{{ plan2YearlyPrice }}</p>

            <span class="tok-card__pill align-self-start fw-bold text-nowrap rounded-pill text-uppercase">
              {{ inheritedLabel }}
            </span>

            <div class="tok-card__features row row-cols-1 row-cols-md-2 g-0 my-4 flex-grow-1">
              <div class="col" *ngFor="let feature of page.features">
                <div class="tok-card__feature d-flex align-items-start pe-md-3">
                  <span class="tok-card__check flex-shrink-0" aria-hidden="true">
                    <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <circle cx="12" cy="12" r="12" fill="currentColor" />
                      <path
                        d="M6 12.5L10 16.5L18 8"
                        stroke="white"
                        stroke-width="2.5"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                      />
                    </svg>
                  </span>
                  <span>{{ feature }}</span>
                </div>
              </div>
            </div>

            <button
              type="button"
              class="tok-card__cta d-inline-flex align-items-center justify-content-center w-100 lh-1 fw-bold rounded-pill"
              (click)="buyTok(tokStripePlanId)"
            >
              {{ page.ctaText }}
            </button>
          </div>
        </div>
      </div>

      <div class="col-lg-4 col-12 order-lg-1" *ngIf="isMultiPlanTok && plan1Available">
        <app-plan-card
          variant="base"
          [title]="plan1Name"
          [subtitle]="plan1Title"
          [price]="plan1YearlyPrice"
          [features]="plan1Benefits"
          ctaText="Complete your transfer"
          (selectPlan)="buyTok(plan1StripePlanId)"
        ></app-plan-card>
      </div>
    </div>

    <p class="text-center mt-4 mb-0">
      <a href="/terms-and-conditions" target="_blank" class="tok-card__terms">Terms and conditions</a>
    </p>

  </div>

  <app-background-icon-collection />
</section>
